import { useMutation, UseMutationOptions } from 'react-query';
import { APIError } from '~/src/utils/error';
import { useCurrentOrgFprint } from '../../user';
import { fieldMappingService } from '../services';
import type {
  FieldMappingSnapshotData,
  FieldMappingSnapshotResponse,
} from '../types';

type SaveFieldMappingSnapshotVariables = {
  projectId: number;
  data: FieldMappingSnapshotData;
};

export const useSaveFieldMappingSnapshot = (
  options: UseMutationOptions<
    FieldMappingSnapshotResponse | void,
    APIError,
    SaveFieldMappingSnapshotVariables
  > = {},
) => {
  const orgFprint = useCurrentOrgFprint();

  return useMutation<
    FieldMappingSnapshotResponse | void,
    APIError,
    SaveFieldMappingSnapshotVariables
  >({
    mutationFn: ({ projectId, data }) =>
      fieldMappingService.saveFieldMappingSnapshot(orgFprint, projectId, data),
    ...options,
  });
};
